// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@ces/App/SharedStyles/CartLineSharedStyles";
import { orderLinesListStyles } from "@ces/Overrides/Components/OrderLinesList";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.cartLineContainerStyles = {
    remove: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 5;
                grid-row: 5 / 6;
                gap: 12px;
                margin-top: 4px;
                padding-left: 0;
            }
        `,
    },
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

orderLinesListStyles.productImageLink = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.orderLineCardImage = {
    height: "99px",
    width: "99px",
    css: css`
        img {
            object-fit: contain;
            aspect-ratio: 1/1;
        }
    `,
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
                css: css`
                    @media print {
                        padding-top: 0;
                    }
                `,
            }),
        },
    },
};

orderLinesListStyles.shippedProductInfoSubtotalHeadingAndText = {
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
                css: css`
                    padding-top: 0;
                    margin-bottom: 12px;
                `,
            }),
        },
        heading: {
            ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading, {
                css: css`
                    display: block;
                    line-height: 13px;
                    margin-bottom: 8px;
                    color: ${color("text")};

                    ${xScreen("lte", "md")} {
                        padding-top: 6px;
                    }
                `,
            }),
        },
    },
};

orderLinesListStyles.unShippedProductInfoSubtotalHeadingAndText = {
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
                css: css`
                    padding-top: 0;
                `,
            }),
        },
        heading: {
            ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading, {
                css: css`
                    display: block;
                    line-height: 13px;
                    margin-bottom: 8px;
                    color: ${color("text")};
                `,
            }),
        },
    },
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
                css: css`
                    @media print {
                        padding-top: 0;
                    }
                `,
            }),
        },
    },
};

orderLinesListStyles.priceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

orderLinesListStyles.lableText = {
    ...mergeWithCss(cartLineSharedStyles.qtyLabel, {
        css: css`
            ${xScreen("gt", "md")} {
                display: block;
            }
        `,
    }),
};

orderLinesListStyles.readOnlyNotesText = {
    wrapper: {
        css: css`
            margin-top: 5px;
        `,
    },
};

orderLinesListStyles.qtyOrderedField = {
    valueText: {
        css: css`
            margin-bottom: 12px;
            @media print {
                font-size: 16px;
            }
        `,
    },
    qtyLabel: {
        css: css`
            display: block;
        `,
    },
    qtyLabelNotEditable: {
        css: css`
            &&& {
                display: block;
                margin-bottom: 8px;
                @media print {
                    font-size: 12px;
                }
            }
        `,
    },
};

orderLinesListStyles.qtyUnShippedField = {
    qtyLabel: {
        css: css`
            display: block;
        `,
    },
    qtyLabelNotEditable: {
        css: css`
            &&& {
                display: block;
                margin-bottom: 8px;
                @media print {
                    font-size: 12px;
                }
            }
        `,
    },
    valueText: {
        css: css`
            @media print {
                font-size: 16px;
                line-height: 19px;
                font-weight: 700;
            }
        `,
    },
};

orderLinesListStyles.productInfoSectionOptionsGridItem = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productInfoSectionOptionsLableText = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

orderLinesListStyles.productInfoSectionOptionsValueText = {
    ...cartLineSharedStyles.configurationOptionText,
};

orderLinesListStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

orderLinesListStyles.orderLineInfoPromotionText = {
    ...cartLineSharedStyles.promotionNameText,
};

orderLinesListStyles.promotionsContainer = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productQtyContainer = {
    css: css`
        ${xScreen("lte", "md")} {
            padding-top: 6px;
        }
        @media print {
            display: table;
            content: "";
            clear: both;
            width: 100%;
            max-width: 250px;
            > div:first-child {
                float: left;
                padding-right: 40px;
            }
        }
    `,
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.linesHeaderStyles = {
    total: {
        css: css`
            border: none;
        `,
    },
};

orderLinesListStyles.cartLinesListHeaderStyles = {
    wrapper: {
        css: css`
            ${xScreen("gte", "md")} {
                border: none;
            }
        `,
    },
};

orderLinesListStyles.badgesContainer = {
    ...cartLineSharedStyles.badgesContainer,
};

orderLinesListStyles.productOrderPriceContainer = {
    css: css`
        @media print {
            padding-top: 6px;
        }
    `,
};
